import styled from "styled-components";

import { ListItemCountry } from "@similarweb/ui-components";

import { StyledSignalTag } from "../SignalEventListItem/styles";

export const StyledListItemCountry = styled(ListItemCountry)`
    padding: 0;

    font-family: inherit;
    font-weight: inherit;
    font-size: inherit;
    color: currentcolor;
    background-color: transparent;

    pointer-events: none;

    &.ListItem {
        height: fit-content;
    }

    & .ListItemCountry-icon {
        margin-right: 4px;
        height: 12px;
        width: 12px;

        svg {
            height: inherit;
            width: inherit;
        }
    }
`;

export const StyledTag = styled(StyledSignalTag)`
    margin-left: 0;
`;
